import { ThrowLiteError } from '../lite-error.js';
import { DV, U8 } from '../engine/typed-arrays.js';

function parseGlbContainer(buffer) {
  const view = new DV(buffer);
  const magic = view.getUint32(0, true);
  if (magic !== 1179937895) {
    ThrowLiteError(133);
  }
  let offset = 12;
  const jsonLength = view.getUint32(offset, true);
  const jsonType = view.getUint32(offset + 4, true);
  if (jsonType !== 1313821514) {
    ThrowLiteError(134);
  }
  const jsonStr = new TextDecoder().decode(new U8(buffer, offset + 8, jsonLength));
  const json = JSON.parse(jsonStr);
  offset += 8 + jsonLength;
  const binLength = view.getUint32(offset, true);
  const binType = view.getUint32(offset + 4, true);
  if (binType !== 5130562) {
    ThrowLiteError(135);
  }
  const binChunk = new DV(buffer, offset + 8, binLength);
  return { json, binChunk };
}

export { parseGlbContainer };
//# sourceMappingURL=gltf-glb-parser.js.map
